"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var invariant_1 = __importDefault(require("invariant"));
var lodash_1 = __importDefault(require("lodash"));
var ddp_1 = __importDefault(require("./ddp"));
var RocketChatSockClient = /** @class */ (function () {
    function RocketChatSockClient(options) {
        var _this = this;
        this.is_reconnect_enabled = true;
        this.reconnect_timeout = 500;
        this.on = function (event, handler) {
            invariant_1["default"](_this.ddp, 'RocketChatSock#on: Connection is not set');
            _this.ddp.on(event, handler);
        };
        this.subscribe = function () {
            var _a;
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            invariant_1["default"](_this.ddp, 'RocketChatSock#subscribe: Connection is not set');
            return (_a = _this.ddp).subscribe.apply(_a, params);
        };
        this.handleDisconnect = function () {
            if (!_this.autoReconnect)
                return null;
            _this.autoReconnect();
        };
        if (options) {
            var is_reconnect_enabled = options.is_reconnect_enabled, reconnect_timeout = options.reconnect_timeout;
            if (lodash_1["default"].isBoolean(is_reconnect_enabled))
                this.is_reconnect_enabled = is_reconnect_enabled;
            if (lodash_1["default"].isNumber(reconnect_timeout))
                this.reconnect_timeout = reconnect_timeout;
        }
        this.setupReconnect();
    }
    RocketChatSockClient.prototype.connect = function (url) {
        if (this.ddp)
            this.ddp.close();
        this.ddp = new ddp_1["default"]({ url: url, is_connect_auto: true });
        this.ddp.on('disconnected', this.handleDisconnect);
        // this.ddp.on('error', this._autoReconnect)
    };
    RocketChatSockClient.prototype.setupReconnect = function () {
        var _this = this;
        if (!this.is_reconnect_enabled)
            return null;
        this.autoReconnect = lodash_1["default"].debounce(function (e) {
            if (!_this.ddp)
                return null;
            if (!_this.is_reconnect_enabled)
                return null;
            _this.ddp.reconnect();
        }, this.reconnect_timeout);
    };
    RocketChatSockClient.prototype.disconnect = function () {
        if (!this.ddp)
            return null;
        this.ddp.removeListener('disconnected', this.handleDisconnect);
        this.ddp.close();
        delete this.ddp;
    };
    RocketChatSockClient.prototype.close = function () {
        this.disconnect();
        if (this.autoReconnect)
            this.autoReconnect.cancel();
    };
    RocketChatSockClient.prototype.login = function (params) {
        invariant_1["default"](this.ddp, 'RocketChatSock#login: Connection is not set');
        return this.ddp.call('login', params);
    };
    RocketChatSockClient.prototype.logout = function () {
        invariant_1["default"](this.ddp, 'RocketChatSock#logout: Connection is not set');
        this.ddp.logout();
    };
    return RocketChatSockClient;
}());
exports["default"] = RocketChatSockClient;
